/* eslint-disable */
/** 與 Community 相同來源：加拿大參考油價（加元） */
const OPENVAN_FUEL_URL = "https://openvan.camp/api/fuel/prices";

/**
 * @returns {{ cadPerLiter: number, currency: string, fetchedAt?: string, unit?: string }}
 */
export async function fetchCanadaGasolinePricePerLiter() {
  const res = await fetch(OPENVAN_FUEL_URL);
  const json = await res.json();
  if (!json.success || !json.data?.CA) throw new Error("無法讀取油價");
  const row = json.data.CA;
  const price = row.prices?.gasoline;
  if (price == null || Number.isNaN(Number(price))) throw new Error("無汽油價格");
  let cadPerLiter = Number(price);
  const unit = row.unit || "liter";
  if (unit === "gallon") {
    cadPerLiter /= 3.78541;
  }
  return {
    cadPerLiter,
    currency: row.local_currency || row.currency || "CAD",
    fetchedAt: row.fetched_at || "",
    unit: "liter",
  };
}

export function estimateTripFuelLiters(distanceKm, litersPer100km) {
  const km = Number(distanceKm);
  const l100 = Number(litersPer100km);
  if (!km || km <= 0 || !l100 || l100 <= 0) return null;
  return (km * l100) / 100;
}

export function estimateTripFuelCad(distanceKm, litersPer100km, cadPerLiter) {
  const L = estimateTripFuelLiters(distanceKm, litersPer100km);
  const p = Number(cadPerLiter);
  if (L == null || !p || p <= 0) return null;
  return L * p;
}

/** 每公里汽油費（加元）：(L/100km ÷ 100) × 每升價 */
export function fuelCadPerKm(litersPer100km, cadPerLiter) {
  const l100 = Number(litersPer100km);
  const p = Number(cadPerLiter);
  if (!l100 || l100 <= 0 || !p || p <= 0) return null;
  return (l100 / 100) * p;
}
